<template>
  <div v-if="isDefined">
    <vx-tooltip :text="allSamples" position="bottom" delay=".3s">
      {{ firstRange.sampleStart }} - {{ firstRange.sampleEnd }} <small v-show="hasMultiple">*</small>
    </vx-tooltip>
  </div>
</template>

<script>
export default {
  name: 'SampleRangeCellRenderer',
  computed : {
    hasMultiple() {
      return this.params.data.sampleRanges.length > 1;
    },
    firstRange() {
      return this.params.data.sampleRanges[0];
    },
    isDefined() {
      return this.params.data.sampleRanges !== null && this.params.data.sampleRanges.length >= 1;
    },
    allSamples() {
      if (this.params.data.sampleRanges) {
        let result = "";
        this.params.data.sampleRanges.forEach(range => {
          result += "[" + range.sampleStart + " - " + range.sampleEnd + "],"
        });

        return result.slice(0, -1);

      }
      return "";
    }
  }
}
</script>
